var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5452 15.9542C63.4887 17.3497 62.9528 20.1481 64.3482 22.2046C65.7436 24.2612 68.542 24.7971 70.5986 23.4017C72.6551 22.0062 73.191 19.2078 71.7956 17.1513C70.4002 15.0947 67.6018 14.5588 65.5452 15.9542Z",
    fill: "#8E4DD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4579 38.8053C30.3153 39.5805 30.0176 41.1352 30.7928 42.2777C31.5681 43.4203 33.1227 43.718 34.2653 42.9428C35.4078 42.1675 35.7055 40.6129 34.9303 39.4703C34.155 38.3278 32.6004 38.0301 31.4579 38.8053Z",
    fill: "#8E4DD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8532 21.0073L36.3059 19.5237L40.4381 13.1466L41.9217 20.5992L48.2988 24.7314L40.8464 26.2154L36.714 32.5922L35.2303 25.1395L28.8532 21.0073Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73385 36.0803L10.7542 36.7895L16.1571 32.2511L15.4479 39.2714L19.9863 44.6743L12.9661 43.9655L7.56309 48.5036L8.27226 41.4832L3.73385 36.0803Z",
    fill: "#3897FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.433 73.3045L27.2786 71.2882L28.5144 67.1256L30.5308 70.9714L34.6934 72.207L30.8478 74.2234L29.6119 78.386L27.5956 74.5405L23.433 73.3045Z",
    fill: "#00A98F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.68a9db0be17455e5002c6a111237e716.svg";
export { ForwardRef as ReactComponent };